// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P9KH0","largestCol":"styles_largestCol__1mMca","smallestCol":"styles_smallestCol__1p5ga"};